import { useEffect } from "react";
import { usePDF } from "@react-pdf/renderer";
import { LeavesReviewResponse } from "views/LeavesReview/types";
import { LeavesSummaryPDF } from "./LeavesSummaryPDF";
import { Button, Icon } from "@octano/global-ui";

interface Props {
  data: LeavesReviewResponse;
  selectedDate: Date | null;
  userFullName?: string;
  userRut?: string;
}

const DownloadLeavesSummaryButton = ({
  data,
  selectedDate,
  userFullName,
  userRut,
}: Props) => {
  const [instance, update] = usePDF({
    document: (
      <LeavesSummaryPDF
        data={data}
        selectedDate={selectedDate}
        userFullName={userFullName}
        userRut={userRut}
      />
    ),
  });

  useEffect(() => {
    update();
  }, [data, selectedDate, userFullName, userRut, update]);

  const disabled = instance.loading || !!instance.error;
  const userName = userRut || userFullName?.replace(/\s+/g, "_") || "resumen";
  const fileName = `permisos_vacaciones_${userName}.pdf`;

  return (
    <Button
      outlined
      size="md"
      text="DESCARGAR RESUMEN"
      disabled={disabled}
      onClick={() => {
        if (instance.url) {
          const a = document.createElement("a");
          a.href = instance.url;
          a.download = fileName;
          a.target = "_blank";
          a.rel = "noopener noreferrer";
          a.click();
        }
      }}
      icon={<Icon name="download" size={16} />}
    />
  );
};

export default DownloadLeavesSummaryButton;
